module.exports = __webpack_public_path__ + "static/media/table_icon.b6da2b52.svg";